// ===================================
// UTILS - Ley de redondeo del efectivo
// ===================================
// El redondeo a la decena rige solo para pagos en efectivo (artículo 12). Misma regla que
// `Redondeo.aplicarLeyRedondeo` del backend: 1 a 5 de unidad baja, 6 a 9 sube.

export const redondearEfectivo = (monto: number): number => {
  const unidades = monto % 10;

  if (unidades === 0) return monto;

  return unidades >= 1 && unidades <= 5
    ? Math.floor(monto / 10) * 10
    : Math.ceil(monto / 10) * 10;
};

/**
 * Total que deben sumar los pagos: el de las líneas redondeado si todos los pagos son en
 * efectivo; en cualquier otro caso (hay otros medios de pago) el total exacto.
 */
export const totalEsperadoDePagos = (
  totalLineas: number,
  medios: readonly string[],
  medioEfectivo: string
): number =>
  medios.length > 0 && medios.every(medio => medio === medioEfectivo)
    ? redondearEfectivo(totalLineas)
    : totalLineas;
